// ABOUTME: This component displays the gene-level multi-endpoint Manhattan plot viewer in an iframe.
// ABOUTME: It loads a Panel app for comparing gene-level associations across multiple phenotypes.

import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { UserAuthService } from '../../services/user-auth.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-gene-level-multi',
  templateUrl: './gene-level-multi.component.html',
  styleUrl: './gene-level-multi.component.scss',
})
export class GeneLevelMultiComponent implements OnInit {
  plotEndpoint: string = environment.baseUrl + 'gene_level_gwas/plot';
  plotSrc: SafeResourceUrl | undefined;
  isLoading = true;

  constructor(
    public auth: UserAuthService,
    public sanitize: DomSanitizer,
    private router: Router,
  ) {}

  ngOnInit() {
    this.loadPlot();
  }

  loadPlot() {
    this.plotSrc = this.sanitize.bypassSecurityTrustResourceUrl(
      this.plotEndpoint + '?token=' + this.auth.getToken() + '&app=gene_multi',
    );
    this.isLoading = false;
  }

  goBack(): void {
    this.router.navigate(['/gwas-16']);
  }
}
